/*
  This hook triggers view GA event for instore offer tiles
*/
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { usePrevious } from 'core/hooks/usePrevious';
import { triggerInstoreOfferTilesIsViewedGaEvent } from 'core/modules/Instore2/actions';

export const useTriggerInstoreTileIsViewedGaEvent = (offers) => {
  const dispatch = useDispatch();
  const prevOffer = usePrevious(offers);

  useEffect(() => {
    if (isEmpty(prevOffer) && !isEmpty(offers)) {
      dispatch(triggerInstoreOfferTilesIsViewedGaEvent(offers));
    }
  }, [offers]);
};
